import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from '../helper/helper.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class AutoCheckoutService {

  // https://devapi.travelx.ai/api/autocheckoutform?deviceid=9fee70e2d5b2e6a5&session_id=1587711453595&page=1&version=2&count=10&key=bcqvmn2gabuu&pid=trxa&uuid=18f2f566-46b3-4001-9aa9-591fa812d97a&lang=en&currency=INR&s_id=1587711453595&platformid=9fee70e2d5b2e6a5&utm_source=&utm_campaign=&utm_medium=&dpi=480&userid=&platform=android&ignorepastflight=1&storeid=4012&userid=1

  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  constructor(private httpClient: HttpClient, private helperService: HelperService, private envService: EnvironmentConfigService) {
    this.initApiParams();
  }

  public get autoCheckoutApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.autoCheckoutApi = `${this.envService.autoCheckoutFormApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }
  public set autoCheckoutApi(value: string) {
  }


  initApiParams() {
    this.apiParams = {};
  }

  getAutoCheckoutForm(storeId) {
    this.apiParams.storeid = storeId;
    return this.httpClient.get<any>(this.autoCheckoutApi);
  }

}
